import { CommonModule } from '@angular/common';
import { Component, Inject, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import moment from 'moment';
import { IconModule } from 'src/app/icon/icon.module';
import { PARAM_OPERATOR } from 'src/app/shared/constants';
import { IFilterTable } from 'src/app/shared/interfaces/ITable';
import { convertTimeToUTC, isValidDate, isValidTime } from 'src/app/shared/utils';
import { DataTableComponent } from '../data-table.component';
import { FilterTableComponent } from '../filter-table/filter-table.component';
import { FilterTableV2Component } from '../filter-table-v2/filter-table-v2.component';
import { TableActionsComponent } from '../table-actions/table-actions.component';

@Component({
  selector: 'app-top-table',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatFormFieldModule, MatInputModule, FormsModule, TranslateModule, IconModule, FilterTableComponent, FilterTableV2Component, TableActionsComponent],
  templateUrl: './top-table.component.html',
  styleUrls: ['./top-table.component.scss']
})
export class TopTableComponent {
  @Input() filterTableConfig?: IFilterTable;
  @Input() handleFilterTable: (filterText: string) => void;
  @Input() currentSearchText: string;
  @Input() keyword = '';
  searchField: string[] = [];

  constructor(
    @Inject(DataTableComponent) public parentTable: DataTableComponent) { }

  initSearch() {
    this.searchField = this.parentTable.tableConfig?.columnConfig?.filter((column) => column.searchable).map((column) => column.key) ?? [];
  }

  onSearch(event?: KeyboardEvent) {
    if (!event || (event.key === 'Enter' && this.currentSearchText !== this.keyword)) {
      this.keyword = this.currentSearchText || '';
      let searchStr = '';
      if (this.keyword) {
        searchStr = `${this.searchField.join()}[${PARAM_OPERATOR.LIKE}]${this.keyword}`;
      }
      if (isValidDate(this.keyword)) {
        const dateFormat = moment(this.currentSearchText, ['DD-MM-YYYY', 'DD/MM/YYYY', 'DD.MM.YYYY']).format('YYYY-MM-DD');
        searchStr = `${this.searchField.join()}[${PARAM_OPERATOR.LIKE}]${dateFormat}[DATE]`;
      } else if (isValidTime(this.keyword)) {
        const utcTime = convertTimeToUTC(this.keyword);
        searchStr = `${this.searchField.join()}[${PARAM_OPERATOR.LIKE}]${utcTime}[DATE]`;
      }
      this.parentTable.params.globalSearch = searchStr;
      this.parentTable.retrieveData(true, false);
    }
  }

  clearSearch(): void {
    this.currentSearchText = '';
    if (this.keyword) {
      this.keyword = '';
      this.parentTable.params.globalSearch = '';
      this.parentTable.retrieveData(true, false);
    }
  }
}
